var DEVICE_TYPES;
(function (DEVICE_TYPES) {
  DEVICE_TYPES["MOBILE"] = "mobile";
  DEVICE_TYPES["DESKTOP"] = "desktop";
  DEVICE_TYPES["TABLET"] = "tablet";
})(DEVICE_TYPES || (DEVICE_TYPES = {}));
var deviceTypes = DEVICE_TYPES;

export { deviceTypes as d };
//# sourceMappingURL=deviceTypes-76b869e3-9b9b478e.js.map
